module.exports = __webpack_public_path__ + "img/DSC_2775-xs.115b9586.png";